import { useEffect } from 'react';

import useResettingState from 'hooks/useResettingState.hook';
import useTip from 'hooks/useTip.hook';

const useResettingTip = (init, mode) => {
  const [value] = useResettingState(init, mode);
  const tip = useTip(value);
  const { set } = tip;

  // NOTE: force the tip to a different state only if `value` changes
  useEffect(() => void set(value), [set, value]);

  return tip;
};

// noinspection JSUnusedGlobalSymbols
export default useResettingTip;
